export default "__VITE_ASSET__Bh9N6k3U__"